import React from 'react';
import { Login, SatCoreRegister, contentManager } from 'sat-core';

const RegistrationMessage = ({ t }) => {
  return (
    <div className='signin-message'>
      <a
        href={contentManager.resourceIFrameUrl || ''}
        rel='noopener noreferrer'
        target='_blank'>
        {t('helpAndQuestions')}
      </a>
    </div>
  );
};

const LoginOverride = (props) => {
  return (
    <Login {...props}
      showMinimalFooter={true}
      // registrationMessage={<RegistrationMessage {...props} />} 
    />
  );
};
SatCoreRegister('Login', LoginOverride);
